<ng-container *transloco="let t;">
  <div class="contract-control-step-four">
      <h2 class="step-heading-title">{{t('Heading text (contractControl stepForm) - Managers')}}</h2>
  
      <div class="input-group input-group-merge mb-1">
          <div class="input-group-prepend">
              <span class="input-group-text"><i data-feather="search"></i></span>
          </div>
          <ng-autocomplete class="form-control CC_autoCompleteSearch px-0" #auto  [data]="managersAndGroups" (inputChanged)="searchManagers($event)" [searchKeyword]="keyword" [placeholder]="t('Search placeholder text (contractControl stepForm) - Search managers')" (selected)='selectEvent($event);auto.clear()' [itemTemplate]="itemTemplate" (inputCleared)="inputCleared($event)" [notFoundTemplate]="notFoundTemplate" [isLoading]="loading"></ng-autocomplete>
          <ng-template #itemTemplate let-item>
              <a [innerHTML]="item.name"></a>
          </ng-template>
          <ng-template #notFoundTemplate let-notFound> 
              <div [innerHTML]="notFound"></div>
          </ng-template>
      </div>
  
      <div class="card card-transaction CC_managersContainer mb-0" [formGroup]="mainFormGroup">
          <ng-container formArrayName="managers">
              <div class="transaction-item managerListHover" *ngFor="let manager of managersControl.controls; let i = index;">
                <ng-container [formGroupName]="i">
                  <div class="media">
                    <div class="avatar me-1">
                      <span class="avatar-content">{{ manager?.get('name').value | shortName }}</span>
                    </div>
                    <div class="media-body">
                      <h6 class="transaction-title">{{ manager?.get('name').value }}</h6>
                      <small>{{ manager?.get('email') ? manager?.get('email')?.value : 'No email' }}</small>
                    </div>
                  </div>
                  <div class="fw-bolder listOptionHide">
                    <div class="text-danger font-small-2 cursor-pointer" (click)="removeManager(i)" placement="auto" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Delete (general) - Delete')">{{t('Delete (general) - Delete')}}</div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            
      </div>
  </div>
  </ng-container>